import { render, staticRenderFns } from "./28.vue?vue&type=template&id=bc556e62&"
import script from "./28.vue?vue&type=script&lang=js&"
export * from "./28.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports